"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var between = exports.between = function between() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  var leftIndex = str.indexOf(left);
  var rightIndex = str.indexOf(right);
  return str.substr(leftIndex + left.length, rightIndex - leftIndex - right.length);
};

/*
* Naive approach warning:
*   An exhaustive debounce function is not needed by the tracker.
*   Please do not copy + paste this function :)
*/
var debounce = exports.debounce = function debounce(fn, wait) {
  var timeout = void 0;
  var result = void 0;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(function () {
      timeout = null;
      result = fn.apply(null, args);
    }, wait);
    return result;
  };

  return debounced;
};

var defaults = exports.defaults = function defaults() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var blueprint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var withDefaults = Object.keys(blueprint).reduce(function (accumulator, key) {
    var value = source[key];

    if (value === undefined) {
      accumulator[key] = blueprint[key];
    }

    return accumulator;
  }, {});

  return _extends({}, source, withDefaults);
};

var isArray = exports.isArray = function isArray(thing) {
  if (Array.hasOwnProperty("isArray")) {
    return Array.isArray(thing);
  }
  return Object.prototype.toString.call(thing) === "[object Array]";
};

var makeUuid = exports.makeUuid = function makeUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var v = void 0;
    var r = Math.random() * 16 | 0;
    if (c === "x") {
      v = r;
    } else {
      v = r & 0x3 | 0x8;
    }
    return v.toString(16);
  });
};

var mapObject = exports.mapObject = function mapObject() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var iteratee = arguments[1];

  return Object.keys(source).reduce(function (accumulator, key) {
    accumulator[key] = iteratee(key, source[key]);
    return accumulator;
  }, {});
};

var omit = exports.omit = function omit() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var blacklistMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return Object.keys(source).reduce(function (accumulator, key) {
    var includes = list.indexOf(key) !== -1;
    var shouldOmit = blacklistMode ? includes : !includes;

    if (!shouldOmit) {
      accumulator[key] = source[key];
    }

    return accumulator;
  }, {});
};

var once = exports.once = function once(fn) {
  var isCached = void 0;
  var result = void 0;
  return function () {
    if (!isCached) {
      isCached = true;
      result = fn.apply(undefined, arguments);
    }
    return result;
  };
};

var pluck = exports.pluck = function pluck(subject, collection) {
  var intMode = isArray(collection);
  var base = intMode ? [] : {};
  return Object.keys(collection).reduce(function (accumulator, key) {
    var parsedKey = intMode ? parseInt(key, 10) : key;
    var entry = collection[parsedKey];
    accumulator[parsedKey] = entry[subject];
    return accumulator;
  }, base);
};

var trim = exports.trim = function trim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var outer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (typeof str.trim === "function") {
    str = str.trim();
  } else {
    // IE8 doesn't support String.trim()
    str = str.replace(/^\s+|\s+$/g, "");
  }

  if (str.indexOf(outer) === 0) {
    str = str.substr(outer.length);
  }

  if (str.indexOf(outer) === str.length - outer.length) {
    str = str.substr(0, str.indexOf(outer));
  }

  return str;
};

var shallowCopy = exports.shallowCopy = function shallowCopy() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(source).reduce(function (accumulator, key) {
    accumulator[key] = source[key];
    return accumulator;
  }, {});
};

var cleanUrl = exports.cleanUrl = function cleanUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var cleaned = url;
  try {
    cleaned = cleaned.split("?")[0].split("#")[0];
    if (cleaned.length > 100) {
      cleaned = cleaned.substr(0, 100);
      cleaned = cleaned + "[...]";
    }
    cleaned = cleaned.replace(/(\d)+/g, "*");
  } catch (err) {
    cleaned = "parsing error";
  }
  return cleaned;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.87/js/common/helpers.js
// module id = 51
// module chunks = 0